export class LoggerImpl {

    static LOG_LEVELS = { TRACE: 0, DEBUG: 1, INFO: 2, WARN: 3, ERROR: 4, SILENT: 10};
    private logLevel = 0;
    private pfx = '';

    private logCommon(level: number, consoleFunc:  (...pars: any) => void, ...msg: any): void {
        if (level >= this.logLevel) {
            if (this.pfx) {
                consoleFunc(this.pfx, ...msg);
            }
            else {
                consoleFunc(...msg);
            }
        }
    }

    public trace(...msg: any): void {
        this.logCommon(LoggerImpl.LOG_LEVELS.TRACE, console.log, ...msg);
    }

    public debug(...msg: any): void {
        this.logCommon(LoggerImpl.LOG_LEVELS.DEBUG,console.log, ...msg);
    }

    public info(...msg: any): void {
        this.logCommon(LoggerImpl.LOG_LEVELS.INFO, console.log, ...msg);
    }

    public warn(...msg: any): void {
        this.logCommon(LoggerImpl.LOG_LEVELS.WARN, console.warn,...msg);
    }

    public error(...msg: any): void {
        this.logCommon(LoggerImpl.LOG_LEVELS.ERROR, console.error, ...msg);
    }

    public setLevel(level: number): void {
        this.logLevel = level;
    }

    public setPrefix(pfx: string): void {
        this.pfx = pfx;
    }

    public exportInstanceToGlobal(globalName: string): void {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        window[globalName]  = this;
    }

}

// Export a new Instance of the Logger class
export const log = new LoggerImpl();
export const LOG_LEVEL = LoggerImpl.LOG_LEVELS;